import { apiSlice } from '../../apiSlice';

export const overlappingSemesterAPI = apiSlice
  .enhanceEndpoints({ addTagTypes: ['Semesters'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getSemesters: build.query({
        query: (param) => ({
          url: '/mgmt/semesters',
          method: 'GET',
          params: param,
        }),
        providesTags: ['Semesters'],
      }),
      getOverlappingSemesters: build.query({
        query: ({ year, semesterDiv }) => ({
          url: `/mgmt/semesters/overlap/${year}/${semesterDiv}`,
          method: 'GET',
        }),
        providesTags: ['Semesters'],
      }),
      saveOverlappingSemesters: build.mutation({
        query: (data) => ({
          url: `/mgmt/semesters/overlap`,
          method: 'POST',
          data: data,
        }),
        invalidatesTags: ['Semesters'],
      }),
      deleteOverlappingSemester: build.mutation({
        query: ({ overlapTypeCode, learningYearCode, semesterDiv, overlapYearCode, overlapSemesterDiv }) => ({
          url: `/mgmt/semesters/overlap/${overlapTypeCode}/${learningYearCode}/${semesterDiv}/${overlapYearCode}/${overlapSemesterDiv}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Semesters'],
      }),
    }),
  });

export const {
  useGetSemestersQuery,
  useLazyGetOverlappingSemestersQuery,
  useSaveOverlappingSemestersMutation,
  useDeleteOverlappingSemesterMutation,
}: any = overlappingSemesterAPI;
